"use client";

import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Verified = createSVGIcon(
  <>
    <path
      d="M0.0722487 3.44965L8.50452 0L16.9368 3.44965C16.9368 3.44965 17.079 10.4287 16.9368 11.7248C16.7946 13.0209 16.4491 14.7557 14.0515 17.1685C11.6539 19.5813 8.50452 20 8.50452 20C8.50452 20 5.07065 19.3619 2.91687 17.1685C0.763085 14.9751 0.234811 13.0209 0.0722487 11.7248C-0.0903131 10.4287 0.0722487 3.44965 0.0722487 3.44965Z"
      fill="currentColor"
    />
    <path
      d="M5 9.85185L7.18457 12.0364L12.0364 7.18457"
      stroke="#fff"
      strokeLinecap="round"
    />
  </>,
  "Verified",
  { viewBox: "0 0 17 20", titleAccess: "Verified" }
);
